module.exports = __webpack_public_path__ + "img/2006.1624f642.jpg";